import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { login, logout, setOverLimitChecks } from "../store/userSlice";
import axiosAPI from "../config/axiosInstance";

const useAuth = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const { isLoggedIn } = useSelector((state) => state.user);

  const publicPaths = [
    "/",
    "/portal/login",
    "/portal/signup",
    "/forgot-password",
  ];

  useEffect(() => {
    const validateUser = async () => {
      const token = localStorage.getItem("token");

      // Public routes with no token
      if (publicPaths.includes(location.pathname) && !token) {
        setIsLoading(false);
        return;
      }

      if (!token) {
        handleLogout();
        return;
      }

      try {
        const res = await axiosAPI("get", "auth/validate");

        if (res.auth) {
          dispatch(login({ user: res.userData }));
          dispatch(setOverLimitChecks(res.overLimits));
        } else {
          handleLogout();
        }
      } catch (error) {
        handleLogout();
      } finally {
        setIsLoading(false);
      }
    };

    const handleLogout = () => {
      dispatch(logout());
      localStorage.removeItem("token");
      navigate("/portal/login", { replace: true });
      setIsLoading(false);
    };

    validateUser();
  }, [location.pathname, dispatch, navigate]);

  return { isLoading, isLoggedIn };
};

export default useAuth;
